import jwtDecode from "jwt-decode";
import { defineAuthDriver, Token } from "./auth-http-driver";
import { Auth, HttpDriver } from "vue-auth3";
import { RoleCode } from "./roles";

export default defineAuthDriver({
  tokens: ["access_token", "id_token", "refresh_token"],
  request(auth, options, token) {
    if (options.data && options.data.grant_type == "refresh_token") {
      options.data.refresh_token = localStorage.getItem("auth_token_refresh");
    } else {
      options.headers["Authorization"] = "Bearer " + token;
    }

    return options;
  },

  response(auth, res) {
    updateRoles(auth, res);
    res.data && res.data.refresh_token && localStorage.setItem("auth_token_refresh", res.data.refresh_token);

    return res.data.access_token && res.data.roles.some((r: string) => true)
      ? res.data.access_token.trim()
      : null;
  },
});

const updateRoles = (auth: Auth, res: Awaited<ReturnType<HttpDriver["request"]>>) => {
  const token = res.data.access_token || auth.token();
  if (token) {
    const decodedToken = jwtDecode<Token>(token);
    let roles: string[] = [];
    decodedToken.authorization.map((x) => Object.keys(x)).forEach((x) => (roles = roles.concat(x)));
    res.data.roles = roles;
  }
};
